<template>
  <div id="view">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <!-- 轮播图列表 -->
      <div class="bannerList" v-show="pageShow == 'index'">
        <!-- 顶部起始位置 -->
        <div class="topBox flex">

          <ul class="flex">

            <!--  
            <li class="flex">
              <div style="width: 240px">
                <el-input v-model="searchVle" placeholder="请输入"></el-input>
              </div>
            </li>

            <li class="flex" style="margin-left:15px">
              <el-button type="success" size="small" @click="searchFn"
                >搜索</el-button
              >
            </li> -->
          </ul>

          <el-button type="success" size="small" @click="addFn">新增</el-button>
        </div>
        <!-- 顶部结束位置 -->

        <template>
          <el-table border :data="tableData" style="width: 100%">


            <el-table-column prop="name" align="center" label="物流公司">
            </el-table-column>

            <el-table-column prop="expressCode" align="center" label="快递100编码(com)" min-width="140">
            </el-table-column>

            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="success" size="small" @click="editFn(scope.$index)">编辑</el-button>
                <el-button type="danger" size="small" @click="delFn(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <div class="page_box">
          <el-pagination @current-change="changePage" :current-page.sync="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next,jumper" :total="tableTotal">
          </el-pagination>
        </div>
      </div>

      <!-- 轮播入列表 -->

      <!-- 新增轮播 -->
      <div class="addBanner" v-show="pageShow == 'add'">


        <div class="bannnerLi flex">
          <div class="title">物流公司：</div>
          <div style="width: 500px">
            <el-input v-model="listInfo.name" placeholder="请输入物流公司名称"></el-input>
          </div>
        </div>

        <div class="bannnerLi flex">
          <div class="title">快递100编码：</div>
          <div style="width: 500px">
            <el-input v-model="listInfo.expressCode" placeholder="与快递100 com 一致，如 shunfeng、yuantong"></el-input>
          </div>
        </div>

     


        <div class="bannnerLi flex">
          <el-button type="success" :disabled="submitShow" size="small" @click="submitFn">提交</el-button>
          <el-button type="info" size="small" @click="returnFn">返回</el-button>
        </div>
      </div>
      <!-- 新增轮播 -->
    </div>
  </div>
</template>


<script>
import { delTips, throttle } from "@/util/utils";
import wangEditor from "@/components/wangEditor";
import elUpload from "@/components/elUpload";
export default {
  components: {
    wangEditor,
    elUpload,
  },
  data() {
    return {
      // 历史记录
      historyArr: ["物流公司"],

      // 搜索
      searchVle: "",

      currentPage: 1,
      pageSize: 10,
      tableTotal: 0,
      pageShow: "index",
      tableData: [],

      submitShow: false,
      listInfo: {
        type: "",
      },
    };
  },
  created() { },
  mounted() {
    this.selListFn(1); //查询
  },
  methods: {
    // 添加历史
    historyFn(title, str) {
      this.historyArr.push(title);
      this.pageShow = str;
    },

    // 分页
    changePage: function (res) {
      this.currentPage = res;
      this.selListFn(res);
    },

    // 搜索
    searchFn: function (res) {
      this.currentPage = 1;
      this.selListFn(1);
    },

    // 获取富文本
    getTxt: function (res) {
      this.depict = res;
    },


    // 查询
    selListFn: function (page) {
      if (page) {
        this.currentPage = page;
      }
      var obj = {
        page: this.currentPage || 1,
        size: this.pageSize || 0,
      };

      this.$https(this.$api.api.selLogistics, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data;
          this.tableTotal = res.data.size;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
        }
      });
    },

    // 新增
    addFn: function (res) {
      this.historyFn("新增", "add");
      this.submitShow = false;
      this.listInfo = {
        name: "",
        expressCode: "",
      };
    },

    // 图片上传前




    // 删除
    delFn: delTips(function (index) {
      var list = this.tableData[index];
      this.$https(
        this.$api.api.delLogistics,
        {
          id: list.id,
        },
        "GET"
      ).then((res) => {
        if (res.data.code == 200) {
          this.submitShow = false;
          this.$message.success("操作成功");
          this.selListFn(this.currentPage)
        } else {
          this.$message.error("操作失败");
        }
      });
    }),

    // 轮播编辑
    editFn: function (index) {
      var list = this.tableData[index];
      this.historyArr.push("编辑");
      this.pageShow = "add";
      this.listInfo = list;
    },

    //提交
    submitFn: throttle(function (res) {
      var data = this.listInfo;

      if (!data.name) {
        this.$message.error("请输入公司");
        return;
      }


      var urls = "";
      var obj = {
        name: data.name,
        expressCode: data.expressCode != null ? String(data.expressCode).trim() : "",
      };

      if (data.id) {
        urls = this.$api.api.upLogistics;
        obj.id = data.id;
      } else {
        urls = this.$api.api.addLogistics;
      }

      this.submitShow = true;
      this.$https(
        urls,
        obj,
        "POST"
      ).then((res) => {
        if (res.data.code == 200) {
          this.returnFn()
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
      });

    }),

    // 返回
    returnFn: function (res) {
      this.historyArr.pop();
      this.pageShow = "index";
      this.selListFn(1); //查询
    },
  },
};
</script>

<style scoped lang="less">
#mainBox {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;

  // 头部
  .topBox {
    width: 100%;
    margin-bottom: 10px;
    text-align: right;
    justify-content: space-between;
  }

  .bannerTop {
    margin-bottom: 20px;
  }

  /* 头部起始位置 */
  .el-header {
    height: 50px !important;
    line-height: 50px;
    border-bottom: 2px solid #bebebe;
  }

  .banner {
    width: 100%;
    overflow: hidden;

    .el-icon-plus,
    img {
      width: 200px;
      height: 110px;
      border: 2px dashed #dedede;
      line-height: 120px;
      text-align: center;
      font-size: 28px;
      color: #999;
    }

    .Btn {
      background: red;
      margin-left: 15px;
    }
  }

  // 轮播图列表
  .bannerImg {
    width: 180px;
    height: 70px;
    margin: auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .bannerList {
    width: 100%;
  }

  // 新增图片
  .addBanner {
    width: 100%;
    padding: 5px 20px;
    box-sizing: border-box;
  }

  .bannnerLi {
    width: 100%;
    margin-bottom: 30px;

    .title {
      width: 110px;
      flex-shrink: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/logistics/index.vue